<ng-form #documentForm="ngForm" novalidate class="form__cont" *ngIf="folderCopy$ | async as folder">
  <h2 class="form__title">{{folder.propertiesObj?.FolderName}}</h2>

  <div class="tabs__control">
    <ul class="inline-list">
      <li>
        <button matTooltip="Save" *ngIf="documentForm.valid" mat-icon-button (click)="save(folder)">
          <mat-icon><img src="assets/images/icon-save.svg" /></mat-icon>
        </button>
      </li>
      <li>
        <button matTooltip="Close" mat-icon-button [routerLink]="['../..','browse',(folder$ | async)?.parentID]">
          <mat-icon><img src="assets/images/icon-close.svg" /></mat-icon>
        </button>
      </li>
    </ul>
  </div>


  <mat-tab-group class="tabs__section" #tabs>
    <mat-tab label="Folder Settings">
      <mat-card class="mat-card-sub">
        <h3 class="full__section">Folder Settings </h3>

        <div class="form-container full__section">
          <mat-form-field appearance="outline">
            <mat-label>Folder Description</mat-label>
            <input matInput #email="ngModel" name="FolderDescription"
              [(ngModel)]="folder.propertiesObj.FolderDescription"
              matTooltip="A definition of what the folder is intended for, to assist users in selecting the most appropriate location for the contract to be uploaded. This definition will be displayed as a tool tip to the user" />

          </mat-form-field>

        </div>
        <div class=" form-container" matTooltip="The email recipients who will receive 90 day and 30 day alerts">
          <app-multiselect-email #email="ngModel" [required]="folder.propertiesObj.ClassDescription === 'LibraryFolder'"
            name="FolderToAdresses" [(ngModel)]="folder.propertiesObj.FolderToAdresses" label="Alert To Addresses">
          </app-multiselect-email>
        </div>

        <div class=" form-container"
          matTooltip="The email recipients who will be copied on the 90 day and 30 day alerts">
          <app-multiselect-email [required]="false" name="FolderCCAdresses"
            [(ngModel)]="folder.propertiesObj.FolderCCAdresses" label="Alert CC Addresses">
          </app-multiselect-email>
        </div>

        <div class=" form-container"
          matTooltip="The recipients that alerts will be escalated to when the 3 day alert is sent (RCOs)">
          <app-multiselect-email [required]="false" name="FolderEscallateAdresses"
            [(ngModel)]="folder.propertiesObj.FolderEscallateAdresses" label="Alert Escalation Addresses">
          </app-multiselect-email>
        </div>

        <div></div>


        <div class="form-container"
          matTooltip="Alerts are sent at 1am per country. i.e. Argentina is 3 hrs behind GMT. When it is 1am in Argentina it is 4am on GMT therefore the offset is 4 hours.
        Russia is 3 hours ahead of GMT. When it is 1am in Russia it is 10pm on GMT therefore the offset is -4 hours. (3hrs of GMT difference + 1hr for 1am; if the country is ahead then the offset is negative; if the country is behind then the offset is positive)">
          <mat-form-field appearance="outline">
            <mat-label>Alert GMT Timezone offset</mat-label>
            <input matInput #telephone="ngModel" name="AlertEmailOffset"
              [(ngModel)]="folder.propertiesObj.AlertEmailOffset" />
          </mat-form-field>

          <div class="form-container">
            <section class="custom-check-box-group">
              <mat-checkbox class="custom-check-box" name="FolderDisableEmail"
                [(ngModel)]="folder.propertiesObj.FolderDisableEmail">Disable Automated Email</mat-checkbox>
            </section>
          </div>

          <div class="form-container" *ngIf="folder.propertiesObj?.ClassDescription === 'CategoryFolder'">
            <section class="custom-check-box-group">
              <mat-checkbox class="custom-check-box" name="FolderMasterDataRequired"
                [(ngModel)]="folder.propertiesObj.FolderMasterDataRequired">Master Data is required</mat-checkbox>
            </section>
          </div>

          




        </div>

        <div class="form-container alert-checkboxes"
        matTooltip="This enables or disbles 60/180 day alerts for the selected email addresses">
          <section class="custom-check-box-group">
            <mat-checkbox class="custom-check-box" name="chkSixtyDayAlert"
            [(ngModel)]="folder.propertiesObj.Folder60DayAlert">Enable 60 Day Alert</mat-checkbox>
          </section>
          <section class="custom-check-box-group">
            <mat-checkbox class="custom-check-box" name="chkOneHundredEightyDayAlert"
            [(ngModel)]="folder.propertiesObj.Folder180DayAlert">Enable 180 Day Alert</mat-checkbox>
          </section>
        </div>
      </mat-card>
    </mat-tab>
    <mat-tab label="Folder Permissions">
      <mat-card class="mat-card-sub"
        matTooltip="User permissions can only be amended on those records that have an icon in the Action column. If there is no icon then user permissions are inherited from the Folder one level up and must be managed at that level.
To change a user's access Level, click on the Access Level link and it will change from Initiator to Read or Read to Initiator. To remove a user, click the trashcan. To add a new user click the 'Add Permission' button.">
        <app-permissions name="acl" [(ngModel)]="folder.acl" [editMode]="true"></app-permissions>
      </mat-card>
    </mat-tab>
    <mat-tab label="Audit Trail">
      <mat-card class="mat-card-sub">
        <app-audit-view [audits]="folder?.audits" [objectStore]="(folderID$ | async)?.objectStore"></app-audit-view>
      </mat-card>
    </mat-tab>
  </mat-tab-group>






</ng-form>


<!-- {{folder$ | async | json}} -->
